import { useLanguage } from './language-context';
import { useTheme } from './theme-context';

// The light/dark switch (FR-X9). One button with a sun half and a moon half, the
// active half filled — the customer design's top-bar control (Others.dc.html L140-147).
// Pressing it pins the opposite of what is showing; until then the device decides.
export function ThemeToggle({ variant = 'bar' }: { variant?: 'rail' | 'bar' }) {
  const { resolved, setPref } = useTheme();
  const { t } = useLanguage();
  const dark = resolved === 'dark';
  return (
    <button
      type="button"
      className={variant === 'rail' ? 'theme-toggle theme-toggle--rail' : 'theme-toggle'}
      aria-label={t(dark ? 'theme.switch_to_light' : 'theme.switch_to_dark')}
      title={t(dark ? 'theme.current_dark' : 'theme.current_light')}
      data-resolved={resolved}
      onClick={() => setPref(dark ? 'light' : 'dark')}
    >
      <span className={dark ? 'theme-toggle__half' : 'theme-toggle__half is-active'} aria-hidden="true">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 3v1.6M12 19.4V21M3 12h1.6M19.4 12H21M5.64 5.64l1.13 1.13M17.23 17.23l1.13 1.13M18.36 5.64l-1.13 1.13M6.77 17.23l-1.13 1.13" />
        </svg>
      </span>
      <span className={dark ? 'theme-toggle__half is-active' : 'theme-toggle__half'} aria-hidden="true">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.98 13.79a8.5 8.5 0 0 1-10.77-10.7A8.5 8.5 0 1 0 20.98 13.8Z" />
        </svg>
      </span>
    </button>
  );
}
